import { http } from "@shared/utils/request";

/** 站点项 StoreSitesItemData */
export interface StoreSitesItemData {
    countryCode: string;
}

export interface StoreSitesData {
    items: StoreSitesItemData[];
}

/** GET /customer/store/sites — 从当前企业店铺表去重查询站点编码 */
export function fetchStoreSites(): Promise<StoreSitesData> {
    return http.get<StoreSitesData>("/customer/store/sites");
}
